import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { EnumModel } from '../../models/enum-model';
import { OrdersService } from '../../home/services/orders.service';
import {CardExtensionModel, CardReorderModel} from '../../models/card-reorder-model';
import { CardReorderReason } from '../../dto/card-reorder-reason';
import {CardsService} from '../../home/services/cards.service';

@Component({
  selector: 'app-card-extension-dialog',
  templateUrl: './card-extension-dialog.component.html',
  styleUrls: ['./card-extension-dialog.component.css']
})
export class CardExtensionDialogComponent implements OnInit {
  public title = 'Extend card';
  public text = 'Are you sure you want to extend this card?';


  public publicToken: string;
  public comment: string;

  constructor(
    public dialogRef: MatDialogRef<CardExtensionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    if (this.data == null) {
return;
}

    this.publicToken = this.data.publicToken;

    if ( this.data.title ) {
this.title = this.data.title;
}
    if ( this.data.text ) {
this.text = this.data.text;
}

  }

  onYesClick(): void {
    const model = new CardExtensionModel();
    model.publicToken = this.publicToken;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
